<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-card>
      <v-card-title>
        Novo item ao contrato
      </v-card-title>
      <v-card-text>
        <EducationSystemSelect
          @setEducationSystem="parameters.education_system_id = $event"
        />
        <EducationStageSelect
          :education-system-id="parameters.education_system_id"
          @setEducationStage="parameters.education_stage_id = $event"
        />
        <GradeSelect
          ref="gradeSelectComponent"
          :education-stage-id="parameters.education_stage_id"
          @setGrade="parameters.grade_id = $event"
        />

        <div class="d-flex">
          <v-checkbox
            label="Conteudos de vídeo"
            v-model="parameters.has_media"
            class="pr-4"
          />
          <v-checkbox
            label="Atividades"
            v-model="parameters.has_activity"
          />
        </div>
        <div class="d-flex">
          <v-checkbox
            label="Banco de questões"
            v-model="parameters.has_question_bank"
            class="pr-4"
          />
          <v-checkbox
            label="Material didático"
            v-model="parameters.has_textbook"
          />
        </div>
        <div class="d-flex">
          <v-select
            v-model="parameters.publishing_year"
            class="px-2"
            :items="years"
            :disabled="!parameters.has_textbook"
            item-text="name"
            item-value="value"
            label="Ano do material(teorico)"
          />
          <v-select
            v-model="parameters.publishing_year_additional"
            class="px-2"
            :items="years"
            :disabled="!parameters.has_textbook"
            item-text="name"
            item-value="value"
            label="Ano do material(complementares)"
          />
        </div>

        <div class="d-flex align-center justify-space-between mt-10">
          <v-checkbox
            label="Continuar adicionando"
            v-model="shouldContinue"
            class="pr-4"
          />
          <v-btn
            depressed
            @click="onCancel()"
          >
            fechar
          </v-btn>
          <v-btn
            :disabled="!parameters.grade_id"
            depressed
            @click="newContractItem()"
          >
            Salvar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import EducationSystemSelect from '@/components/contents/EducationSystemSelect.vue'
import EducationStageSelect from '@/components/contents/EducationStageSelect.vue'
import GradeSelect from '@/components/contents/GradeSelect.vue'

export default {
  components: {
    EducationSystemSelect,
    EducationStageSelect,
    GradeSelect
  },

  props: {
    contractId: { type: Number, required: true }
  },

  data: () => ({
    parameters: {
      education_system_id: null,
      education_stage_id: null,
      grade_id: null,
      publishing_year: new Date().getFullYear(),
      publishing_year_additional: new Date().getFullYear(),
      has_media: true,
      has_activity: true,
      has_question_bank: true,
      has_textbook: true
    },
    years: [
      new Date().getFullYear() + 1,
      new Date().getFullYear(),
      new Date().getFullYear() - 1,
      new Date().getFullYear() - 2,
      new Date().getFullYear() - 3
    ],
    shouldContinue: false
  }),

  methods: {
    onCancel () {
      this.$emit('resolve', false)
    },

    async newContractItem () {
      try {
        await this.$api.newContractItem(this.contractId, this.parameters)
        this.shouldC()
      } catch (error) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível adicionar item ao contrato, tente novamente mais tarde.', color: 'red' })
      }
    },
    shouldC () {
      if (this.shouldContinue) {
        this.$refs.gradeSelectComponent.grade_id = null
        return
      }
      this.$emit('resolve', true)
    }
  }
}
</script>
